import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getNewsflashDetails, updateNewsflash } from '../../../actions/newsflashActions';
import Message from '../../Message/Message';
import Loader from '../../Loader/Loader';
import FormContainer from '../../FormContainer/FormContainer';
import Meta from '../../Helmet/Meta';
import './list.css'

const NewsflashEditScreen = ({ match, history }) => {
  const newsflashId = match.params.id;

  const [titre, setTitre] = useState('');
  const [text, setText] = useState('');
  const [link, setLink] = useState('');

  const dispatch = useDispatch();

  const newsflashDetails = useSelector((state) => state.newsflashDetails);
  const { loading, newsflash, error } = newsflashDetails;

  const newsflashUpdate = useSelector((state) => state.newsflashUpdate);
  const { loading: loadingUpdate, success: successUpdate, error: errorUpdate } = newsflashUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: 'NEWSFLASH_UPDATE_RESET' });
      history.push('/newsflashlist');
    } else {
        if (  newsflash._id !== newsflashId) {   

        dispatch(getNewsflashDetails(newsflashId));
      } else {
        setTitre(newsflash.titre);
        setText(newsflash.text);
        setLink(newsflash.link);
      }
    }
  }, [newsflash, newsflashId, dispatch, successUpdate, history]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(updateNewsflash({ _id: newsflashId, titre,text, link }));
  };


  const handleFileChange = (e) => {
    const link = e.target.files[0];
    if (link) {
      // Process the selected file as needed
      console.log('Selected File:', link.name);
      // You can set the file name or path to the state or perform other operations.
      setLink(link.name);
    }
  };
  return (
    <>
    <div  className="main"  fluid >
      <Meta title=" | News-flash Edit" />
      <FormContainer >
        <h1 >Modification du News-flash </h1>
        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <Form onSubmit={submitHandler} style={{ marginBottom: '50px' }}>

       
          <Form.Group controlId="titre">
          <Form.Label>Titre <span style={{ color: 'red' }}>*</span></Form.Label>
          <Form.Control
           type="text"
           value={titre}
           onChange={(e) => setTitre(e.target.value)}
          />
          </Form.Group>
          
        <br />  <br />
    
            <Form.Group controlId="text">
              <Form.Label>Description <span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </Form.Group>

            <br />  <br />

            <Form.Group controlId="link">
              <Form.Label>Document : <span style={{ color: 'red' }}>*</span></Form.Label>
              <Form.Control
                value={link ?? ""}
                type="text"
              />
            </Form.Group>

            <Form.Group controlId="link">
              <Form.Label> <span style={{ color: 'red' }}>Pour modifier un fichier, choisissez Nouveau lien</span></Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange}
              />
            </Form.Group>
            <Button type="submit" style={{ backgroundColor: 'red' }}>
              Mettre à jour
            </Button>
          </Form>
        )}
      </FormContainer>
      </div>
    </>
  );
};

export default NewsflashEditScreen ;
